import type { Router } from 'vue-router';

// 1:1 port of Angular's `ErrorRouter` (customer-apps/error/error-router.service.ts):
// `redirect(status)` navigates to the error page with the HTTP status attached. Angular passes it
// as a matrix parameter (`navigate(['/error', { status }])`); vue-router has none, so it becomes a
// query parameter — the same deliberate deviation the module gate in every app router already uses.
//
// Angular can inject the Router anywhere; in Vue it only exists inside a component setup or a
// navigation guard. `useAppInit()` runs outside both, so each app registers its instance at boot.
let router: Router | null = null;

export function registerErrorRouter(instance: Router): void {
    router = instance;
}

export function redirectToError(status: number | string): void {
    if (!router) {
        return;
    }
    // `replaceUrl: true` in Angular — the failed route must not stay in the history.
    const locale = (router.currentRoute.value.params.locale as string | undefined) ?? 'de';
    void router.replace({ path: `/${locale}/error`, query: { status: String(status) } });
}
